import { useTranslation } from 'react-i18next';
import { Input } from 'reactstrap';

// SP-8g §3 — modalità `self_claim` (presa in carico libera = coda comune)
// rimossa: lo split deve sempre assegnare a operatori specifici.
export type SplitMode = 'manual' | 'auto_qty' | 'criteria';

export interface StepModeSelectProps {
  value: SplitMode | null;
  onChange: (next: SplitMode) => void;
}

export function StepModeSelect({ value, onChange }: StepModeSelectProps) {
  const { t } = useTranslation('picklist');
  const modes: SplitMode[] = ['manual', 'auto_qty', 'criteria'];
  return (
    <div className="d-flex flex-column gap-2">
      {modes.map((m) => (
        <label
          key={m}
          className={`d-block border rounded p-3 mb-0 ${value === m ? 'border-primary bg-primary-subtle' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          <Input
            className="me-2"
            type="radio" name="split-mode" value={m}
            checked={value === m}
            onChange={() => onChange(m)}
          />
          <strong>{t(`wizard.mode_select.${m}`)}</strong>
          <p className="small text-muted mt-1 mb-0">
            {t(`wizard.mode_select.descriptions.${m}`)}
          </p>
        </label>
      ))}
    </div>
  );
}
